export const commonIs = {
  nav: {
    home: 'Heim',
    about: 'Um okkur',
    menu: 'Matseðill',
    wineList: 'Vínseðill',
    contact: 'Hafðu samband',
    reservations: 'Bóka borð',
    careers: 'Atvinna',
    aboutSub: {
      ourStory: 'Sagan okkar',
      joinTeam: 'Vertu með í teyminu',
    },
    menuSub: {
      foodMenu: 'Matseðill',
      wineList: 'Vínseðill',
    },
    contactSub: {
      getInTouch: 'Hafðu samband',
      findUs: 'Finndu okkur',
    },
  },
  viewItem: 'Skoða rétt',
  footer: {
    about:
      'Ekta napólsk matargerð í hjarta Reykjavíkur. Fersk hráefni, hefðbundnar uppskriftir og ekti bragð Ítalíu.',
    social: {
      title: 'Fylgstu með okkur',
    },
    hours: {
      title: 'Opnunartími',
      weekdays: 'Mánudagur – Laugardagur',
      weekdaysTime: '12:00 – 22:00',
      sunday: 'Sunnudagur',
      sundayTime: '17:00 – 22:00',
    },
    contact: {
      title: 'Hafðu samband',
      address: 'Laugavegi 40a, 101 Reykjavík',
      phone: '561 0500',
      email: 'larusg@simnet.is',
      hours: {
        weekdays: 'Mánudagur - Laugardagur: 12:00 - 22:00',
        sunday: 'Sunnudagur: 17:00 - 22:00',
      },
    },
    quickLinks: {
      title: 'Flýtileiðir',
      home: 'Heim',
      about: 'Um okkur',
      menu: 'Matseðill',
      wineList: 'Vínseðill',
      contact: 'Hafðu samband',
      careers: 'Atvinna',
    },
    newsletter: {
      title: 'Fylgstu með',
      description: 'Skráðu þig á póstlistann okkar fyrir sértilboð, nýja rétti og viðburði.',
      placeholder: 'Netfangið þitt',
      button: 'Skrá',
      subscribing: 'Skrái...',
      success: {
        title: 'Takk fyrir að skrá þig!',
        message: 'Þú munt fá uppfærslur um sértilboð okkar, nýja rétti og sérstaka viðburði.',
        autoClose: 'Þessi tilkynning mun lokast sjálfkrafa',
      },
    },
    copyright: 'Rossopomodoro. Öll réttindi áskilin.',
  },
  credit: {
    text: 'Hannað og smíðað með ástríðu í Reykjavík af',
    company: 'Litljóma',
  },
};
